(function() {
    // 更改 Active Tab 的顯示數量
    var tabsPanel = $('.tabs-panel');
    var shopAmount = $('.shop-amount__item');

    $('[data-tabs]').on('change.zf.tabs', function() {
        const activeEl = tabsPanel.filter('.is-active');
        if (activeEl) {
            const id = activeEl[0].id;
            const amountEl = $(`#shop-amount-${id}`);

            shopAmount.addClass('hide');
            amountEl.removeClass('hide');
        }
    })
})();
